module.exports = __webpack_public_path__ + "img/56.85809577.jpg";